import { GET_CONTACT_INFO, POST_CONTACT_INFO } from '../constants/ActionTypes';

/**
 * Get contact screen propreties.
 * @function getContactInfo
 * @returns {Object} Get the contact screeen propreties
 */
export function getContactInfo() {
  return {
    type: GET_CONTACT_INFO,
    request: {
      op: 'get',
      path: '/@contact-info',
    },
  };
}
export function postContactInfo(name, from, to, subject, message, hcaptcha) {
  return {
    type: POST_CONTACT_INFO,
    request: {
      op: 'post',
      path: '/@contact-info-email-send',
      data: {
        name,
        from,
        to,
        subject,
        message,
        hcaptcha,
      },
    },
  };
}
